import { formatWithAccentCanadianRegion, getCountryRegionDataFromOrganizationCountry } from "@simplyk/common";
import { useSearchParams } from "next/navigation";

import { GetCurrentUserFrontendObject } from "../contexts/types";

export const useDefaultCountryRegion = (
  organization: NonNullable<GetCurrentUserFrontendObject["currentOrganization"]>
) => {
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());

  const { country: countryQueryParam, region: regionQueryParam, state: stateQueryParam } = query;
  return {
    defaultCountry: (countryQueryParam ||
      getCountryRegionDataFromOrganizationCountry(organization.country) ||
      "Canada") as string,
    defaultRegion: (regionQueryParam ||
      stateQueryParam ||
      formatWithAccentCanadianRegion(organization.region) ||
      "Québec") as string,
  };
};
